Auth = require 'app/scripts/db/auth'
editInProgressTemplate = require 'app/scripts/views/templates/edit_in_progress'
{ featureFlagClient } = require '@trello/feature-flag-client'
PopOver = require 'app/scripts/views/lib/pop-over'
CardMemberSelectView = require 'app/scripts/views/card/card-member-select-view'
Util = require 'app/scripts/lib/util'
{ track } = require '@trello/analytics'
cardDetailAddButtonTemplate = require 'app/scripts/views/templates/card_detail_add_button'

module.exports.renderEditing = ->
  members = @model.memberEditingList.models

  data =
    members: for mem in members when !Auth.isMe(mem) && mem.get('editing')?
      memberData = mem.toJSON()
      memberData.icon = switch mem.get('editing').action
        when 'commenting' then 'comment'
        when 'editing' then 'edit'
        else 'edit'
      memberData

  if featureFlagClient.get('dataeng.preserve-desc-draft', false)
    commentsData =
      members: data.members.filter (mem) -> mem.icon == 'comment'

    descriptionData =
      members: data.members.filter (mem) -> mem.icon == 'edit'

    @$('.js-editing-members-comments')
      .empty()
      .append editInProgressTemplate(commentsData)
      .toggleClass('hide', commentsData.members.length == 0)

    @$('.js-editing-members-description')
      .empty()
      .append editInProgressTemplate(descriptionData)
      .toggleClass('hide', descriptionData.members.length == 0)
  else
    @$('.js-editing-members-comments')
      .empty()
      .append editInProgressTemplate(data)
      .toggleClass('hide', data.members.length == 0)

  @

module.exports.openEditMembersPopOver = (elem) ->
  PopOver.toggle
    elem: elem
    view: CardMemberSelectView
    options: { @model, @modelCache }
  return

module.exports.editMembersMain = (e) ->
  Util.stop(e)
  @openEditMembersPopOver(@$('.js-details-edit-members'))
  track("Card Detail", "Edit Members via Main Column", undefined, @model.trackProperty())
  return

module.exports.changeMembersSidebar = (e) ->
  Util.stop(e)
  @openEditMembersPopOver(@$('.js-change-card-members'))
  track("Card Detail", "Sidebar", "Open Manage Member Menu", @model.trackProperty())
  return

module.exports.join = (e) ->
  Util.stop(e)
  @model.addMember(Auth.myId())
  track("Card Detail", "Suggested", "Join", @model.trackProperty())

module.exports.renderMembers = (e) ->
  $memberList = @$('.js-card-detail-members-list').empty()
  members = @model.memberList.filterDeactivated(model: @model.getBoard()).models
  memberHtml = (@getMemberOnCardHtml(member) for member in members).join("")
  $memberList.html(memberHtml)

  if @model.editable() && !@isOnBoardTemplate()
    $memberList.append(cardDetailAddButtonTemplate(klass: 'js-details-edit-members mod-round'))

  @$('.js-card-detail-members').toggleClass('hide', members.length == 0)

  @renderSuggestedActions()

  @
